import { Card, Col, Divider, List, Row, Select, Space, Spin, Statistic, Tooltip } from 'antd';
import React, { useState } from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faLineChart } from '@fortawesome/pro-regular-svg-icons';
import UsageStatistic from './UsageStatistic';
import { Icon } from '@fortawesome/fontawesome-svg-core';

interface AdminUsageListProps {
  company: Company | undefined;
}

export default function AdminUsage({
  company,
}: AdminUsageListProps) {
    
  const [range, setRange] = useState(-30);
  const activityUsage = CustomerServiceQueries.useCompanyUsageAdmin(company!.id, range)

  const handleChange = (value: string) => {
    setRange(Number(value))
  };

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faLineChart as Icon}/> Admin App Activity</Space>} extra={<Select
      defaultValue={range.toString()}
      style={{ width: 160 }}
      onChange={handleChange}
      loading={activityUsage.isFetching}
      options={[
        {
            value: "0",
            label: 'All Time',
        },
        {
            value: "-365",
            label: 'Past 365 Days',
        },
        {
            value: "-120",
            label: 'Past 120 Days',
        },
        {
            value: "-90",
            label: 'Past 90 Days',
        },
        {
            value: "-60",
            label: 'Past 60 Days',
        },
        {
            value: "-30",
            label: 'Past 30 Days',
        }
      ]}
    />} >
        <Spin spinning={activityUsage.isLoading}>
            
    <Row gutter={[16,16]}>
        {activityUsage.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item} />
            </Col>
        ))}
    </Row>
        </Spin>
    </Card>
    </>
  );
}
